import { error, log } from '@/services/Log'

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))
/*
  Since google optimize experiement results are not always present on load,
  we need a method to poll for the data OR resort to the default after 500ms.
*/
type ExperimentGetter = (i: {
  experimentId: string
  iteration?: number
}, iteration?: number) => Promise<'1' | '0'>
export const getExperiment: ExperimentGetter = ({
  experimentId,
  iteration = 0,
}) => new Promise((resolve) => {
  // if darkMode is enabled, by cookie etc., use Variant1
  if (iteration >= 10) {
    resolve('0')
  } else {
    log(`getExperiment: ${experimentId} iteration: ${iteration}`)
    log(`type of window google optimize: ${typeof window?.google_optimize?.get}`)
    const variant = window?.google_optimize?.get?.(experimentId)
    if (!variant) {
      resolve('0')
    } else if (variant === '1' || variant === '0') {
      resolve(variant)
    } else {
      sleep(50 + 50 * iteration)
        .then(async () => {
          resolve(await getExperiment({ experimentId }, iteration + 1))
        })
        .catch(error)
    }
  }
})

export default getExperiment
